import { postRequest } from '../utils'

export const saveVerticalTransmissionTarget: RequestTypeVariable = {
  getKey: (projectId: string, hostElementId: string, targetElementId: string) => [
    'saveVerticalTransmissionTarget',
    projectId,
    hostElementId,
    targetElementId,
  ],
  request: async (
    projectId: string,
    hostElementId: string,
    targetElementId: string,
    input: VerticalTransmissionGraph,
    connectionSearchSettings: ConnectionSearchSettings,
    supportGuid?: string,
  ): Promise<VerticalTransmissionGraph> => {
    const params = {
      ...(supportGuid ? { support_guid: supportGuid } : {}),
    }

    const { data } = await postRequest<VerticalTransmissionGraph>({
      url: `/projects/${projectId}/vertical-transmission-graph/connect/${hostElementId}/${targetElementId}`,
      data: {
        graph: input,
        connection_search_settings: connectionSearchSettings,
      },
      params: Object.keys(params).length ? params : undefined,
    })

    return data as VerticalTransmissionGraph
  },
}
